import 'slick-carousel';
import productDetails from './rbmc.pdp';

const pdpSlider = {
    slickReady:        undefined,
    pdpSliderWrapper:  undefined,
    pdpSliderSync:     undefined,
    pdpSliderArea:     undefined,
    pdpMainSliderConf: {
        slidesToShow:   1,
        slidesToScroll: 1,
        arrows:         true,
        swipe:          true,
        lazyLoad:       'ondemand',
        dotsClass:      'pdp__slider-dots',
        appendDots:     '.pdp__navigation',
        prevArrow:      `<svg class="icon pdp__slider-arrow pdp__slider-arrow-left">
                                <use xlink:href="#icon-arrow-left"></use>
                            </svg>`,
        nextArrow:      `<svg class="icon pdp__slider-arrow pdp__slider-arrow-right">
                                <use xlink:href="#icon-arrow-right"></use>
                            </svg>`,
        dots:           true,
        responsive:     [
            {
                breakpoint: 684,
                settings:   {
                    speed: 150,
                }
            }]
    },

    pdpSliderSyncConf: {
        slidesToShow:   5,
        slidesToScroll: 1,
        dots:           false,
        centerMode:     false,
        arrows:         true,
        vertical:       true,
        swipe:          false,
        infinite:       false,
        prevArrow:      `<svg class="icon pdp__slider-nav-arrow-up">
                    <use xlink:href="#icon-arrow-up"></use>
                    </svg>`,
        nextArrow:      `<svg class="icon pdp__slider-nav-arrow-down">
                    <use xlink:href="#icon-arrow-down"></use>
                    </svg>`,
    },

    htmlImageTemplate(src) {
        return `<div class="pdp__slider-nav"><img src="${src}"></div>`;
    },

    goToSlide(slideNumber, noAnimation) {
        this.pdpSliderWrapper.slick('slickGoTo', parseInt(slideNumber), noAnimation);
    },

    goToPersonalizedSlide() {
        if (productDetails.cdnUrl) {
            let personalizedSlideIndex = undefined;

            this.pdpSliderWrapper.slick('getSlick').$slides.each((index, slide) => {
                if ($(slide).find('.pdp__personalize-image').length) {
                    personalizedSlideIndex = slide.dataset.slickIndex;
                }
            });

            if (personalizedSlideIndex) {
                this.goToSlide(personalizedSlideIndex, true);
            }
        }
    },

    setActiveThumb(slideNumber) {
        pdpSlider.pdpSliderSync.find('.slick--current-thumb').removeClass('slick--current-thumb');
        pdpSlider.pdpSliderSync.find('.slick-slide').eq(slideNumber).addClass('slick--current-thumb');
    },

    renderPlayBtnOnDots(slick) {
        slick.$slides.each(function (index, element) {
            if ($(element).find('.pdp__slider-video').length) {
                slick.$dots.children().eq(index).find('button').addClass('pdp__slider-dot--play');
            }
        });
    },

    initiateSliders() {
        pdpSlider.pdpSliderWrapper.on('afterChange', function (event, afterAction, currentSlide) {
                     pdpSlider.setActiveThumb(afterAction.currentSlide);
                 })
                 .on('beforeChange', function (event, slick, currentSlideNum, nextSlideNum) {
                     let isCurrentSlideVideo = slick.$slides.eq(currentSlideNum).find('.pdp__slider-video'),
                         isNextSlideVideo    = slick.$slides.eq(nextSlideNum).find('.pdp__slider-video');

                     // pause video in the current slide
                     if (isCurrentSlideVideo.length) {
                         isCurrentSlideVideo[0].pause();
                     }
                     // play video in next slide
                     if (isNextSlideVideo.length) {
                         isNextSlideVideo[0].play();
                     }
                 })
                 .on('init', function (event, slick) {
                     // add play button to dots navigation on mobile
                     pdpSlider.renderPlayBtnOnDots(slick);
                 })
                 .on('breakpoint', function (event, slick) {
                     pdpSlider.renderPlayBtnOnDots(slick);
                 })
                 .slick(pdpSlider.pdpMainSliderConf);

        pdpSlider.pdpSliderSync.on('init', function (event, slick) {
                     slick.$slides.eq(slick.currentSlide).addClass('slick--current-thumb');
                 })
                 .slick(pdpSlider.pdpSliderSyncConf);

        pdpSlider.slickReady = pdpSlider.pdpSliderWrapper.slick('getSlick');
        pdpSlider.pdpSliderArea.removeClass('pdp__slider--reload');
    },

    destroySliders() {
        pdpSlider.pdpSliderWrapper.slick('unslick');
        pdpSlider.pdpSliderSync.slick('unslick');
    },

    cacheSelectors() {
        pdpSlider.pdpSliderWrapper = $('.pdp__slider');
        pdpSlider.pdpSliderSync    = $('.pdp__sliderSync');
        pdpSlider.pdpSliderArea    = $('.pdp__slider-area');
    },

    bindHandler() {
        pdpSlider.pdpSliderSync.on('click', '.slick-slide', (evt) => {
            let $currentTarget = $(evt.currentTarget);
            let currentIndex   = $currentTarget.data('slickIndex');

            this.goToSlide(currentIndex, true);
            this.setActiveThumb(currentIndex);
        });
    }
};

$(() => {
    if ($('#product-detail-page').length) {
        pdpSlider.cacheSelectors();
        pdpSlider.initiateSliders();
        pdpSlider.bindHandler();
    }
});

export default pdpSlider;
